import { render, staticRenderFns } from "./ProgramCollapse.vue?vue&type=template&id=43310ce7&"
import script from "./ProgramCollapse.vue?vue&type=script&lang=js&"
export * from "./ProgramCollapse.vue?vue&type=script&lang=js&"
import style0 from "./ProgramCollapse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports